interface FloatingLabelTextInputProp {
  type?: string;
  label: string;
  onChange: any;
  isMandatory: boolean;
  value: any;
  name: string;
  disable?: boolean;
  maxLength?: number;
  minValue?: string | number;
  maxValue?: string | number;
  placeholder? : string;
}

const FloatingLabelTextInput = (props: FloatingLabelTextInputProp) => {
  const { onChange } = props;
  const {
    type,
    label,
    isMandatory,
    value,
    name,
    disable,
    maxLength,
    maxValue,
    minValue,
    placeholder,
  } = props;
  return (
    <>
      <div className="wrap-input input-sm label-sm">
        {label && (
          // <label className={`${value != null ? "active" : ""}`}>
          //   {label}
          //   {isMandatory && <i className="label-asterisk">*</i>}
          // </label>
          <label className="profile_details_text">
            {label}
            {isMandatory && <i className="label-asterisk"> * </i>}
          </label>
        )}
        <input
          className="form-control"
          name={name}
          type={type != null ? type : "text"}
          value={value == undefined ? "" : value}
          onChange={(e) => onChange(e)}
          maxLength={maxLength}
          disabled={disable}
          placeholder={placeholder}
          min={minValue}
          max={maxValue}
          onInput={(e) => {
            type == "number" &&
              maxLength &&
              e.currentTarget.value.length > maxLength &&
              (e.currentTarget.value = e.currentTarget.value.slice(
                0,
                maxLength
              ));
          }}
        />
      </div>
    </>
  );
};

export default FloatingLabelTextInput;
